module.exports = __webpack_public_path__ + "img/step2-b.0fd9d621.png";